import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import AodIcon from '@mui/icons-material/Aod';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, setDoc, doc, Timestamp } from 'firebase/firestore';
import {
  getDatabase,
  ref as dbref,
  runTransaction,
  set,
  child,
  get,
  update,
  serverTimestamp,
  push,
} from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { MuiFileInput } from 'mui-file-input';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

dayjs.extend(utc);
dayjs.extend(timezone);

// TODO: Replace the following with your app's Firebase project configuration
// See: https://support.google.com/firebase/answer/7015592
const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const rtdb = getDatabase(app);

// TODO remove, this demo shouldn't need to reset the theme.
export default function NewProductPage() {
  const [loading, setLoading] = React.useState(false);
  const [fileInputError, setFileInputError] = React.useState(false);
  const [thumbnailInputError, setThumbnailInputError] = React.useState(false);
  const [prefixError, setPrefixError] = React.useState(false);
  const [titleError, setTitleError] = React.useState(false);
  const [subtitleError, setSubTitleError] = React.useState(false);
  const [venueError, setVenueError] = React.useState(false);
  const [descriptionError, setDescriptionError] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [thumbnail, setThumbnail] = React.useState(null);
  const [startdate, setstartDate] = React.useState(dayjs.utc());
  const [enddate, setendDate] = React.useState(dayjs.utc());

  const [starttime, setstartTime] = React.useState(dayjs.utc('2022-04-17T12:00'));
  const [endtime, setendTime] = React.useState(dayjs.utc('2022-04-17T13:00'));
  const [prefix, setPrefix] = React.useState('');

  const navigate = useNavigate();

  const handleOnChangeUploadfile = (newFile) => {
    setFile(newFile);
  };

  const handleOnChangeUploadThumbnail = (newFile) => {
    setThumbnail(newFile);
  };

  const handleOnChangePrefix = (event) => {
    setPrefix(event.target.value.trim().toLowerCase());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const data = new FormData(event.currentTarget);

    const auth = getAuth();
    const user = auth.currentUser;

    let filePass = false;
    let thumbnailPass = false;
    let prefixPass = false;
    let titlePass = false;
    let subtitlepass = false;
    let venuepass = false;
    let descriptionpass = false;

    if (file && (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf')) {
      setFileInputError(false);
      filePass = true;
    } else {
      setFileInputError(true);
    }

    if (
      thumbnail &&
      (thumbnail.type === 'image/jpeg' || thumbnail.type === 'image/png' || thumbnail.type === 'application/pdf')
    ) {
      setThumbnailInputError(false);
      thumbnailPass = true;
    } else {
      setThumbnailInputError(true);
    }

    if (data.get('prefix').length > 2) {
      prefixPass = true;
      setPrefixError(false);
    } else {
      setPrefixError(true);
    }

    if (data.get('title').length > 2) {
      titlePass = true;
      setTitleError(false);
    } else {
      setTitleError(true);
    }

    if (data.get('subtitle').length > 2) {
      subtitlepass = true;
      setSubTitleError(false);
    } else {
      setSubTitleError(true);
    }

    if (data.get('venue').length > 2) {
      venuepass = true;
      setVenueError(false);
    } else {
      setVenueError(true);
    }

    if (data.get('description').length > 2) {
      descriptionpass = true;
      setDescriptionError(false);
    } else {
      setDescriptionError(true);
    }

    if (filePass && thumbnailPass && prefixPass && titlePass && subtitlepass && descriptionpass && venuepass) {
      const storage = getStorage(app);
      const storageRef = ref(
        storage,
        `eventbanner/${Timestamp.fromDate(new Date()).toMillis()}_${file.name.replace(/\s/g, '')}`
      );

      // Get a key for a new Post.

      uploadBytes(storageRef, file).then((snapshot) => {
        getDownloadURL(ref(storage, snapshot.metadata.fullPath)).then((url1) => {
          const storageRef2 = ref(
            storage,
            `eventthumbnail/${Timestamp.fromDate(new Date()).toMillis()}_${thumbnail.name.replace(/\s/g, '')}`
          );

          uploadBytes(storageRef2, thumbnail).then((snapshot2) => {
            getDownloadURL(ref(storage, snapshot2.metadata.fullPath)).then((url2) => {
              update(dbref(rtdb, `event/${data.get('prefix')}`), {
                prefix: data.get('prefix'),
                id: data.get('prefix'),
                title: data.get('title'),
                subtitle: data.get('subtitle'),
                description: data.get('description'),
                venue: data.get('venue'),
                created: Timestamp.fromDate(new Date()).toMillis(),
                createdby: user.uid,
                start_date: startdate.format() || null,
                end_date: enddate.format() || null,
                start_time: starttime.format() || null,
                end_time: endtime.format() || null,
                event_bg_fullPath: url1 || null,
                event_bg_contentType: snapshot.metadata.contentType || null,
                thumbnail_fullPath: url2 || null,
                thumbnail_contentType: snapshot2.metadata.contentType || null,
              }).then(() => {
                setLoading(false);
                navigate('/dashboard/event');
              });
            });
          });
        });
      });
    } else {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Grid
        style={{
          width: '100%',
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <AodIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          New Event
        </Typography>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                autoComplete="off"
                name="prefix"
                required
                fullWidth
                id="prefix"
                label="Prefix"
                autoFocus
                error={prefixError}
                value={prefix}
                onChange={handleOnChangePrefix}
                inputProps={{ style: { textTransform: 'lowercase' } }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                fullWidth
                required
                id="title"
                error={titleError}
                label="Title"
                name="title"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
              <TextField
                fullWidth
                required
                id="subtitle"
                error={subtitleError}
                label="Sub Title"
                name="subtitle"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
              <TextField
                fullWidth
                required
                id="venue"
                error={venueError}
                label="Venue"
                name="venue"
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                required
                error={descriptionError}
                id="description"
                label="Description"
                name="description"
                autoComplete="off"
                multiline
                rows={4}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Event Start Date"
                  value={startdate}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setstartDate(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Event End Date"
                  value={enddate}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setendDate(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Event Start Time"
                  value={starttime}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setstartTime(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <LocalizationProvider sx={{ width: '100%' }} dateAdapter={AdapterDayjs}>
                <TimePicker
                  label="Event End Time"
                  value={endtime}
                  timezone="Asia/Singapore"
                  onChange={(newDate) => setendTime(newDate)}
                  sx={{ width: '100%' }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={12}>
              <MuiFileInput
                color="primary"
                required
                style={{ width: '100%' }}
                error={fileInputError}
                placeholder="Upload Background Image*"
                getInputText={(value) => (value ? value.name : 'Upload Background Image*')}
                inputProps={{ accept: 'image/jpeg' }}
                value={file}
                onChange={handleOnChangeUploadfile}
              />
              <Typography style={{ fontSize: 12, color: 'black', marginTop: 10, opacity: 0.6 }}>
                *Image Resolution (W)1920px x (H)1080px
              </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
              <MuiFileInput
                color="primary"
                required
                style={{ width: '100%' }}
                error={thumbnailInputError}
                placeholder="Upload Thumbnail*"
                getInputText={(value) => (value ? value.name : 'Upload Thumbnail*')}
                inputProps={{ accept: 'image/jpeg' }}
                value={thumbnail}
                onChange={handleOnChangeUploadThumbnail}
              />
              <Typography style={{ fontSize: 12, color: 'black', marginTop: 10, opacity: 0.6 }}>
                *Image Resolution (W)500px x (H)280px
              </Typography>
            </Grid>
          </Grid>
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            Add Event
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
